import { Route, Routes } from 'react-router-dom';
import { PopupApproval } from '../approval/PopupApproval';
import { PopupAuthenticating } from '../authenticating/PopupAuthenticating';
import { PopupLogin } from '../login/PopupLogin';
import { WebAuthConfig } from '../../../../shared/types/types';
import { IdToken } from '@auth0/auth0-react';
import { useAuthentication } from '../../primaryAuth';
import { SecondAuth } from '../../secondAuth';

export interface ApprovalPopUpRoutesProps {
  webAuth: auth0.WebAuth;
  webAuthConfig: WebAuthConfig;
  login: (result: IdToken, isApproval: boolean) => void;
}

export function ApprovalPopUpRoutes() {
  const { webAuthConfig, webAuth } = useAuthentication();
  const { secondLogin } = SecondAuth();

  return (
    <>
      <Routes>
        {window.location.pathname === '/handleapprove' && (
          <Route path={window.location.pathname} element={<PopupApproval webAuth={webAuth} webAuthConfig={webAuthConfig} secondLogin={secondLogin} />} />
        )}
        {window.location.pathname === '/handleauth' && (
          <Route path={window.location.pathname} element={<PopupAuthenticating webAuth={webAuth} webAuthConfig={webAuthConfig} />} />
        )}
        {window.location.pathname === '/handlelogin' && (
          <Route path={window.location.pathname} element={<PopupLogin webAuth={webAuth} webAuthConfig={webAuthConfig} />} />
        )}
      </Routes>
    </>
  );
}
